// extracted by mini-css-extract-plugin
module.exports = {"bidTemplate":"styles_bidTemplate__wWbqK","textarea":"styles_textarea__3Ibhg","remove":"styles_remove__3wuVD","cross":"styles_cross__1ogeu","spin":"styles_spin__33Rlx"};